// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Bx","controller":"i_By","label-container":"i_Bz","explainer":"i_B0","informer":"i_B1","modal":"i_B2","static":"i_B3","wrapper":"i_B4"};